export enum TransportType {
    Container = 0,
    Tractor = 1,
  }